import {getDWPInfo, uploadDWPFile} from "../network/DwpNetworkAPI";

export const DWPUploadReducer = (state, action) => {
    switch (action.type) {
        case "HIDE_LOADER":
            return {...state, isLoading: false}
        case "LOAD_DWP_INFO": {
            const {dispatcher, baseUrl, stationConfig} = action.data;
            getDWPInfo(dispatcher, baseUrl, stationConfig);
            return state
        }
        case "RECEIVE_DWP_INFO": {
            return {...state, ...action.data}
        }
        case "UPLOAD_DWP":
            uploadDWPFile(action.data);
            return {...state, isLoading: true}
        case "UNLOAD_VIEW":
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/fileupload/reducers/DWPUploadReducer.js